export const UPLOAD_DOCUMENT_STEP = {
  invalid: 0,
  dragfile: 1,
  preview: 2,
};

export const SOURCES_SORT_ORDER = {
  desc: 'desc',
  asc: 'asc',
};

export const QUESTION_SOURCES_SORTBY = {
  createdAt: 'created_at',
  unresolved: 'unresolved',
  updatedAt: 'updated_at',
};

export const QUESTION_SOURCES_STATES = {
  enabled: 'enabled',
  disabled: 'disabled',
  deleted: 'deleted',
  pending: 'pending',
};

export const DOCUMENT_SOURCES_SORTBY = {
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};

export const WEB_SOURCES_STATES_COLOR = {
  processing: 'primary',
  completed: 'success',
  error: 'alert',
};

export const WEB_SOURCES_SORT_BY = {
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};